import { render, staticRenderFns } from "./Poblation.vue?vue&type=template&id=89c83c72&scoped=true&"
import script from "./Poblation.vue?vue&type=script&lang=js&"
export * from "./Poblation.vue?vue&type=script&lang=js&"
import style0 from "./Poblation.vue?vue&type=style&index=0&id=89c83c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c83c72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
